module.exports = __webpack_public_path__ + "img/img_off@2x.8d3ea874.png";